// The native record-interface designer uses the same renderer as record pages.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { InterfaceBuilder } from '../../../../../features/interface-builder/InterfaceBuilder';

export const Route = createFileRoute('/_focus/settings/objects/$key/layout')({
  validateSearch: z.object({
    record: z.uuid().optional().catch(undefined),
    variant: z.string().max(63).optional().catch(undefined),
  }),
  component: LayoutEditorRoute,
});

function LayoutEditorRoute() {
  const { key } = Route.useParams();
  const { record, variant } = Route.useSearch();
  return <InterfaceBuilder initialRecordId={record} initialVariantId={variant} key={key} objectKey={key} />;
}
